var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#events_svg__clip0_61530_7206)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.5H18V12h1.5a2.253 2.253 0 012.25 2.25v3h1.5v-3a3.755 3.755 0 00-3.75-3.75zM18 3a2.25 2.25 0 110 4.5A2.25 2.25 0 0118 3zm0-1.5A3.75 3.75 0 1018 9a3.75 3.75 0 000-7.5zM17.25 22.5h-1.5V21a2.253 2.253 0 00-2.25-2.25h-3A2.253 2.253 0 008.25 21v1.5h-1.5V21a3.755 3.755 0 013.75-3.75h3A3.755 3.755 0 0117.25 21v1.5zM12 9.75a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm0-1.5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM6 10.5H4.5a3.755 3.755 0 00-3.75 3.75v3h1.5v-3A2.253 2.253 0 014.5 12H6v-1.5zM6 3a2.25 2.25 0 110 4.5A2.25 2.25 0 016 3zm0-1.5A3.75 3.75 0 106 9a3.75 3.75 0 000-7.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "events_svg__clip0_61530_7206"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgEvents;